
import React, { useState } from 'react';
import './PartnerBar.css';

const partners = [
    {
        id: 'fb1',
        name: 'Autókeresztelő Facebook oldal',
        icon: '/images/partners/facebook.png',
        url: 'https://www.facebook.com/autokeresztelo',
        hoverContent: {
            sections: [
                { title: 'Facebook oldal', url: 'https://www.facebook.com/autokeresztelo' },
            ]
        }
    },
    {
        id: 'p1',
        name: 'The Zone',
        icon: '/images/partners/the-zone.png',
        url: 'https://the-zone.hu/',
        hoverContent: {
            youtube: '',
            sections: [
                { title: 'Hírek', url: 'https://the-zone.hu/category/autos-hirek/' },
                { title: 'Olvastár', url: 'https://the-zone.hu/category/olvastar/' },
                { title: 'Youtube', url: 'https://youtube.com/thezone' },
            ]
        }
    },
    {
        id: 'p2',
        name: 'Ámon Olivér',
        icon: '/images/partners/amon.png',
        url: 'https://amonproductions.com/',
        hoverContent: {
            sections: [
                { title: 'Ámon Olivér - Youtube', url: 'https://www.youtube.com/@OliverAmon93' },
                { title: 'Check Engine - Youtube', url: 'https://www.youtube.com/@checkengineyt' },
            ]
        }
    },
    {
        id: 'p3',
        name: 'Becsületesnepper',
        icon: '/images/partners/becsuletesnepper.png',
        url: 'https://becsuletesnepper.hu/',
        hoverContent: {
            sections: [
                { title: 'Becsületesnepper - Weboldal', url: 'https://becsuletesnepper.hu/' },
                { title: 'Becsületesnepper - Youtube', url: 'https://www.youtube.com/@becsuletesnepper1' },
                { title: 'Becsületesnepper a HAHU-n', url: 'https://www.hasznaltauto.hu/partner/becsuletesnepper-10129' }
            ]
        }
    }
];

export default function PartnerBar() {
    const [hovered, setHovered] = useState(null);

    return (
        <div className="partner-bar">
            <p>Az oldal készítői az alábbi tartalmakat fogyasztják:</p>
            <div className="partner-icons">
                {partners.map(p => (
                    <div
                        key={p.id}
                        className="partner-icon"
                        onMouseEnter={() => setHovered(p.id)}
                        onMouseLeave={() => setHovered(null)}
                    >
                        <a href={p.url} target="_blank" rel="noopener noreferrer">
                            <img src={p.icon} alt={p.name} />
                        </a>

                        {hovered === p.id && p.hoverContent && (
                            <div className="partner-hover">
                                <p className="partner-hover-title"><strong>{p.name}</strong></p>
                                <span className="partner-hover-subtitle">Elérhető rovatok & hivatkozások</span>

                                <div className="partner-sections-grid">
                                    {p.hoverContent.sections?.map((section, index) => {
                                        const isLink = typeof section !== 'string' && section.url;
                                        const title = typeof section === 'string' ? section : section.title;
                                        const url = isLink ? section.url : null;

                                        return isLink ? (
                                            <a
                                                key={index}
                                                href={url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="partner-section-chip"
                                            >
                                                <span>{title}</span>
                                                <svg className="chip-arrow" viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
                                                    <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </a>
                                        ) : (
                                            <div key={index} className="partner-section-chip static">
                                                <span>{title}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                    </div>
                ))}
            </div>
        </div>
    );
}
``
